// @flow
import React from 'react';
import styled from 'styled-components';
// import { media } from 'styles/Mixins';
import BoxRadioSelect from 'components/shared/BoxRadioSelectComponent';
import DiscountPaymentComponent from 'components/shared/DiscountPaymentComponent';
import BillPayment from 'components/shared/BillPaymentComponent';
import BackButton from 'components/renter_application/BackButtonComponent';
import * as RenterApp from 'styles/Home/StyledRenterApplication';
import { DashboardHome } from 'utils/ExportCommon';
import * as Layout from 'styles/Layout';
import PaymentMethodStore from 'stores/PaymentMethodStore';
import PaymentMethodActions from 'actions/PaymentMethodActions';
import HomeApplicationStore from 'stores/HomeApplicationStore';
import HomeApplicationActions from 'actions/HomeApplicationActions';
import _ from 'lodash';
import HomieContext from 'HomieContext';
import { Redirect } from 'react-router-dom';
import accounting from 'accounting';
import Spinner from 'components/shared/Spinner';
import YesNoOption from 'components/shared/YesNoOptionComponent';
import AppStore from 'stores/AppStore';
import swal from '@sweetalert/with-react';
import { SubmitButton } from 'styles/Home/StyledRenterApplication';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import SuccessFinalProcess from 'modules/agencies/shared/SuccessFinalProcessComponent';
import { PAYMENT_TYPES } from 'utils/Constants';
import { font } from 'styles/Constants';

const BackButtonContainer = styled(RenterApp.BackButtonContainer)`
  margin-top: ${({ addMargin }) => (addMargin ? 20 : 0)}px;
  margin-left: ${({ addMargin }) => (addMargin ? 20 : 0)}px;
`;

const ProfileContainer = styled(Layout.FlexColumn)`
  width: 100%;
  position: relative;
`;

const ProfileForm = styled(Layout.FlexColumn)`
  width: 300px;
  margin: 5px auto;
  margin-top: ${({ addMargin }) => (addMargin ? 60 : 0)}px;
`;

const Title = styled.span`
  display: block;
  min-height: 22px;
  width: 100%;
  color: #4a4a4a;
  font-size: 18px;
  line-height: 22px;
  margin-bottom: 20px;
  margin-top: ${props => (props.isForAdvisor ? '40px' : '0')};
  padding: ${props => (props.isForAdvisor ? '5px' : '0')};
`;

const Description = styled.div`
  height: 30px;
  width: 300px;
  color: #4a4a4a;
  font-family: ${font.openSans};
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 20px;
`;

const LinkStyle = styled.a`
  height: 19px;
  width: 182px;
  color: ${({ color }) => color};
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 10px;
  &:hover {
    text-decoration: none;
    color: ${({ color }) => color};
  }
`;

const ButtonFinish = styled.div`
  height: 35px;
  width: 300px;
  border-radius: 2px;
  background-color: #278c7e;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
  height: 40px;
  width: 300px;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  line-height: 19px;
  text-align: center;
  cursor: pointer;
  padding-top: 12px;
`;

const LinkStyleFacturar = styled.div`
  color: ${({ color }) => color};
  font-size: 14px;
  line-height: 17px;
  margin-bottom: 10px;
  margin-top: 10px;
  cursor: ${props => (props.clickable ? 'pointer' : 'default')};
  display: ${props => (props.visible ? 'block' : 'none')};
`;

const IconContent = styled.div`
  display: ${props => (props.visible ? 'block' : 'none')};
  width: 13px;
  float: right;
  margin-right: 45%;
`;

const DownArrowIcon = styled(DashboardHome.downArrow)`
  height: 8px;
  width: 13px;
  cursor: pointer;
  & path {
    fill: ${({ color }) => color};
  }
`;

const UpArrowIcon = styled(DownArrowIcon)`
  transform: rotate(-180deg);
  & path {
    fill: ${({ color }) => color};
  }
`;

const Button = styled(SubmitButton)`
  height: 35px;
  width: 270px;
  margin-left: 8px;
  margin-top: 15px;
  &:disabled {
    background: #ececec;
    color: #9b9b9b;
  }
`;

const CancelAppButton = styled(RenterApp.CancelAppButton)`
  width: ${({ isForAdvisor }) => (isForAdvisor ? 'auto' : '50px')};
  height: ${({ isForAdvisor }) => (isForAdvisor ? '24px' : 'auto')};
  top: ${({ isForAdvisor }) => (isForAdvisor ? '22px' : '0')};
  right: ${({ isForAdvisor }) => (isForAdvisor ? '15px' : '45px')};
`;

const LineBreak = styled.div`
  padding-bottom: 20px;
`;

type PropsType = {
  handleChange: () => void,
  nextAction: () => void,
  onPrevStep: () => void,
  onCancel: () => void,
  visibleFormBill: boolean,
  homeId: string,
  homeApp: string,
  homeAppData: any,
  prevStepText: string,
  isForAdvisor?: boolean,
  updateAfterSuccessPayment?: () => void,
  color: string
};

type StateType = {
  boxPaymentOptions: Array<any>,
  activePaymentOption: string,
  arrowDownBill: boolean,
  arrowUpBill: boolean,
  billPaymentDataVisible: boolean,
  visibleFromBillData: boolean,
  billLink: boolean,
  seeBillDataLink: boolean,
  paymentMethod: Array<any>,
  paymentData: any,
  paymentDataTicket: any,
  homeAppData: any,
  showLoading: boolean,
  correctPayment: boolean,
  errorPayment: boolean,
  hideButtonOnRequest: boolean,
  errorTicket: boolean,
  promoCode: string,
  redirectPage?: string,
  promoCodePayComplete: boolean,
  errorPaymentPromo: boolean,
  require_invoice: boolean,
  existLegalEntity: boolean,
  showModalPaymentStubInformation: boolean
};

class PaymentContentComponent extends React.Component<PropsType, StateType> {
  static defaultProps = {
    prevStepText: 'Documentos',
    isForAdvisor: false,
    color: '#278C7E'
  };

  constructor(props: PropsType) {
    super(props);
    this.state = {
      boxPaymentOptions: PAYMENT_TYPES,
      activePaymentOption: 'none',
      arrowDownBill: true,
      arrowUpBill: false,
      billPaymentDataVisible: HomeApplicationStore.getHomeApplication()
        ? HomeApplicationStore.getHomeApplication().require_invoice
        : false,
      visibleFromBillData: false,
      billLink: false,
      seeBillDataLink: true,
      paymentData: null,
      homeAppData: this.props.homeAppData,
      showLoading: false,
      correctPayment: false,
      errorPayment: false,
      hideButtonOnRequest: false,
      errorTicket: false,
      promoCode: '',
      promoCodePayComplete: false,
      errorPaymentPromo: false,
      require_invoice: HomeApplicationStore.getHomeApplication()
        ? HomeApplicationStore.getHomeApplication().require_invoice
        : false,
      existLegalEntity: true,
      showModalPaymentStubInformation: false
    };
  }

  handleClickCreateStub = (data: any): void => {
    this.setState({
      errorTicket: false,
      hideButtonOnRequest: true
    });
    PaymentMethodActions.payApplicationByMethod(
      data,
      this.props.homeAppData.id,
      this.setHomeApplication,
      this.errorPay
    );
  };

  handleGenerateTicket = (paymentMethod: string, subType: string) => {
    let { promoCode } = this.state;
    this.setState({
      errorTicket: false,
      hideButtonOnRequest: true,
      showLoading: true
    });
    let data = {
      home_application_id: this.props.homeAppData.id,
      payment_method: paymentMethod,
      subtype: subType,
      promo_code: promoCode
    };
    PaymentMethodActions.payApplicationByMethod(
      data,
      this.props.homeAppData.id,
      this.setHomeApplicationTicket,
      this.errorPayTicket
    );
  };

  errorPayTicket = (): void => {
    this.setState({
      paymentDataTicket: PaymentMethodStore.errorPayByMethodApp(),
      errorTicket: true,
      hideButtonOnRequest: false,
      showLoading: false
    });
  };

  setHomeApplicationTicket = () => {
    this.setState({
      homeAppData: HomeApplicationStore.getHomeApplication(),
      paymentDataTicket: PaymentMethodStore.payApplicationByMethod(),
      errorTicket: false,
      hideButtonOnRequest: false,
      showModalPaymentStubInformation: true
    });
  };

  errorPay = (): void => {
    this.setState({
      errorPayment: true,
      correctPayment: false,
      showLoading: false,
      paymentData: PaymentMethodStore.errorPayByMethodApp()
    });
  };

  errorPromoPay = (): void => {
    this.setState({
      errorPaymentPromo: true,
      correctPayment: false,
      showLoadingPromo: false,
      paymentData: PaymentMethodStore.errorPayByMethodApp()
    });
  };

  setHomeApplication = () => {
    this.setState({
      homeAppData: HomeApplicationStore.getHomeApplication(),
      errorPayment: false,
      correctPayment: true,
      showLoading: false,
      paymentData: PaymentMethodStore.payApplicationByMethod(),
      seeBillDataLink:
        !!HomeApplicationStore.getHomeApplication().payment ||
        !!PaymentMethodStore.payApplicationByMethod()
    });
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    if (this.props.updateAfterSuccessPayment) {
      this.props.updateAfterSuccessPayment(
        PaymentMethodStore.payApplicationByMethod()
      );
    }
  };

  successPayByPromo = () => {
    this.setState({
      homeAppData: HomeApplicationStore.getHomeApplication(),
      errorPaymentPromo: false,
      correctPayment: true,
      showLoadingPromo: false,
      paymentData: PaymentMethodStore.payApplicationByMethod()
    });
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  onChangePaymentStub = () => {
    this.setState({
      paymentData: PaymentMethodStore.payApplicationByMethod()
    });
  };

  handleClickSelect = (id: string): void => {
    this.setState({ activePaymentOption: id });
    const paymentMethod = PaymentMethodStore.getPaymentMethodByModel(
      'home_applications'
    );
    if (paymentMethod) {
      this.setState({ paymentMethod: paymentMethod, errorTicket: false });
    }
  };

  changeArrowWay = (
    arrowDownBill: boolean,
    arrowUpBill: boolean,
    billPaymentDataVisible: boolean,
    visibleFromBillData: boolean
  ): void => {
    this.setState({
      arrowDownBill,
      arrowUpBill,
      billPaymentDataVisible,
      visibleFromBillData
    });
  };

  componentWillMount() {
    PaymentMethodStore.addChangeListener(this.onChangePaymentStub);
    PaymentMethodStore.addChangeListener(this.setHomeApplication);
    this.existDataToBilling();
    if (
      this.state.require_invoice &&
      this.context.currentUser.legal_entity.id
    ) {
      this.setRequireInvoice(this.state.require_invoice);
    } else {
      this.setRequireInvoice(false);
    }
  }

  componentWillUnmount() {
    PaymentMethodStore.removeChangeListener(this.onChangePaymentStub);
    PaymentMethodStore.removeChangeListener(this.setHomeApplication);
  }

  componentDidMount() {
    PaymentMethodActions.getPaymentMethodByModel('home_applications');
  }

  toggleBillingData = () => {
    this.setState(prevState => {
      prevState.arrowDownBill = !prevState.arrowDownBill;
      prevState.arrowUpBill = !prevState.arrowUpBill;
      prevState.billPaymentDataVisible = !prevState.billPaymentDataVisible;
      prevState.visibleFromBillData = !prevState.visibleFromBillData;
      return prevState;
    });
  };

  setRequireInvoice = (require_invoice?: boolean) => {
    this.setState(prevState => {
      if (typeof require_invoice === 'boolean') {
        prevState.homeAppData.require_invoice = require_invoice;
        prevState.seeBillDataLink = require_invoice;
        prevState.billLink = !require_invoice;
      } else {
        const allow_billing = prevState.homeAppData.allow_billing;
        const empty_require_invoice = _.isNil(
          prevState.homeAppData.require_invoice
        );

        if (allow_billing && empty_require_invoice) {
          prevState.homeAppData.require_invoice = true;
        }
      }
      return prevState;
    }, this.updateRequireInvoiceToBackend);
  };

  updateRequireInvoiceToBackend = () => {
    const { currentUser } = this.context;
    const { homeAppData } = this.state;
    HomeApplicationActions.updateUserHomeApplication(
      currentUser.id,
      homeAppData.id,
      {
        home_application: {
          id: homeAppData.id,
          require_invoice: homeAppData.require_invoice,
          ignore_response: true
        }
      }
    );
  };

  handleBill = () => {
    this.toggleBillingData();
    this.setRequireInvoice(true);
  };

  handleNoBill = () => {
    this.onValidChange(false, '');
  };

  handlePromoCode = (promoCode: string, succesCode: any): void => {
    const { homeAppData } = this.state;
    let promoCodePayComplete =
      _.get(succesCode, 'discount_in_amount') &&
      _.get(succesCode, 'discount_in_amount') === homeAppData.amount;
    if (promoCode)
      this.setState({
        promoCode,
        promoCodePayComplete
      });
  };

  renderShowTerminarApplication(
    appWasPayedWithCard: boolean,
    appWasPayedWithPromo: boolean
  ) {
    const { isForAdvisor } = this.props;
    if ((appWasPayedWithCard || appWasPayedWithPromo) && !isForAdvisor)
      return (
        <ButtonFinish
          onClick={() => {
            this.flushHomeApplicationAssets(this.showCompletedApp);
          }}
        >
          Terminar aplicación
        </ButtonFinish>
      );
    if ((appWasPayedWithCard || appWasPayedWithPromo) && isForAdvisor)
      return (
        <SuccessFinalProcess
          showButtonFunction={false}
          showlinkFunction={false}
          principalTitle="¡Listo!"
          subTitle="Hemos recibido correctamente la información."
        />
      );
  }

  updateAfterSuccessPayment = (value: any) => {
    this.props.updateAfterSuccessPayment(this.state.paymentData);
  };

  renderShowPaymentComponent(
    appWasPayedWithCard: boolean,
    promoCodePayComplete: boolean
  ) {
    const { isForAdvisor, color } = this.props;
    if (!appWasPayedWithCard && !promoCodePayComplete)
      return (
        <div>
          <Description
            style={{ display: appWasPayedWithCard ? 'none' : 'block' }}
          >
            Elige tu método de pago
          </Description>
          <div>
            {this.state.boxPaymentOptions.map((element, index) => {
              return (
                <BoxRadioSelect
                  key={index}
                  id={element.id}
                  selected={element.id === this.state.activePaymentOption}
                  text={element.text}
                  visible={!(element.id === this.state.activePaymentOption)}
                  handleClickSelect={this.handleClickSelect}
                  activePaymentOption={this.state.activePaymentOption}
                  paymentMethod={this.state.paymentMethod}
                  handleClickCreateStub={this.handleClickCreateStub}
                  handleGenerateTicket={this.handleGenerateTicket}
                  paymentData={this.state.homeAppData.payment}
                  homeApplicationId={this.props.homeAppData.id}
                  homeAppData={this.props.homeAppData}
                  errorPayment={this.state.errorPayment}
                  correctPayment={this.state.correctPayment}
                  showLoading={this.state.showLoading}
                  hideButtonOnRequest={this.state.hideButtonOnRequest}
                  errorTicket={this.state.errorTicket}
                  promoCode={this.state.promoCode}
                  homeAppAmount={this.props.homeAppData.amount}
                  isForAdvisor={isForAdvisor}
                  color={color}
                />
              );
            })}
          </div>
        </div>
      );
  }

  flushHomeApplicationAssets = (callback: Function) => {
    HomeApplicationStore.flushAssets();
    PaymentMethodStore.flushPaymentData();
    callback();
  };

  showCompletedApp = () => {
    this.goToPage(
      `/inquilino/${this.props.homeAppData.id}/aplicacion-completada`
    );
  };

  goToPage = (basePath: string) => {
    this.setState({
      redirectPage: basePath
    });
  };

  payHomeApplicationCompletePromoCode = () => {
    this.setState({
      showLoadingPromo: true
    });
    const { homeAppData, promoCode } = this.state;
    let payObject = {
      home_application_id: homeAppData.id,
      payment_method: 'promo',
      promo_code: promoCode
    };
    PaymentMethodActions.payApplicationByMethod(
      payObject,
      this.props.homeAppData.id,
      this.successPayByPromo,
      this.errorPromoPay
    );
  };

  onValidChange = (value: string, path: string) => {
    this.setState({
      require_invoice: value,
      billPaymentDataVisible: value
    });
    if (value && this.context.currentUser.legal_entity.id) {
      this.setRequireInvoice(value);
    } else {
      this.existDataToBilling();
      this.setRequireInvoice(false);
    }
  };

  existDataToBilling = () => {
    let { legal_entity } = AppStore.getCurrentUser();
    this.setState({
      existLegalEntity: !!(
        _.get(legal_entity, 'address') &&
        _.get(legal_entity, 'business_name') &&
        _.get(legal_entity, 'email') &&
        _.get(legal_entity, 'rfc')
      )
    });
  };

  errorNotExistLegalEntity = () => {
    if (!this.state.existLegalEntity && this.state.require_invoice)
      return (
        <strong style={{ color: 'red', display: 'block' }}>
          Debe completar sus datos para facturar.
        </strong>
      );
  };

  updateLegalEntityStatus = () => {
    this.setState({
      existLegalEntity: true
    });
    this.setRequireInvoice(true);
  };

  renderGetBill = () => {
    const { color } = this.props;

    const payment = PaymentMethodStore.payApplicationByMethod();
    const homeApplication = HomeApplicationStore.getHomeApplication();

    const hasPaidConfirmed = () =>
      (payment && payment.payment && payment.payment.paid_at) ||
      (homeApplication &&
        homeApplication.payment &&
        homeApplication.payment.paid_at);

    if (!hasPaidConfirmed())
      return (
        <div>
          <RenterApp.Title>¿Vas a requerir factura?</RenterApp.Title>
          <YesNoOption
            name={'require_invoice'}
            value={this.state.require_invoice}
            onValueChange={this.onValidChange}
            color={color}
          />
        </div>
      );
    else return null;
  };

  renderAlertStubCreated = (): void => {
    const { homeAppData, paymentData } = this.state;
    const { color } = this.props;
    let appWasPayedWithCard,
      clabe,
      method = null;
    if (paymentData) {
      appWasPayedWithCard =
        !paymentData.error &&
        _.get(paymentData, 'payment.payment_method') === 'card';
      clabe = _.get(paymentData, 'payment.token');
      method = !appWasPayedWithCard
        ? _.get(paymentData, 'payment.payment_method')
        : null;
    } else {
      appWasPayedWithCard =
        _.get(homeAppData, 'payment.payment_method') === 'card';
      clabe = _.get(homeAppData, 'payment')
        ? _.get(homeAppData, 'payment.token')
        : null;
      method = !appWasPayedWithCard
        ? _.get(homeAppData, 'payment.payment_method')
        : null;
    }

    if (
      clabe &&
      method &&
      this.state.showModalPaymentStubInformation &&
      !appWasPayedWithCard
    )
      swal({
        icon: 'success',
        buttons: {
          cancel: 'Ok'
        },
        content: (
          <div>
            <LineBreak>
              Hay una clabe generada para pagar por
              <LinkStyle color={color}>
                <strong style={{ textTransform: 'uppercase' }}>
                  {' '}
                  {method}{' '}
                </strong>
              </LinkStyle>
              . Le hemos enviado un correo con la información.
            </LineBreak>
            <LineBreak>
              <LinkStyle color={color}>CLABE</LinkStyle> :
              <strong id="clabe_to_copy" style={{ textTransform: 'uppercase' }}>
                {' '}
                {clabe}{' '}
              </strong>
              <CopyToClipboard text={clabe}>
                <Button style={{ width: '120px' }}>Copiar CLABE</Button>
              </CopyToClipboard>
            </LineBreak>
          </div>
        )
      }).then(value => {
        switch (value) {
          default:
            this.setState({ showModalPaymentStubInformation: false });
        }
      });
  };

  renderDescription = (homeAppData: any) => {
    const { color } = this.props;
    return (
      <Description>
        Con este pago de{' '}
        <LinkStyle color={color}>
          ${accounting.formatNumber(homeAppData.amount)}MXN
        </LinkStyle>{' '}
        cubres el costo de tu investigación.
      </Description>
    );
  };

  renderBackButton = () => {
    const { prevStepText, onPrevStep, color, isForAdvisor } = this.props;
    const payment = PaymentMethodStore.payApplicationByMethod();
    const homeApplication = HomeApplicationStore.getHomeApplication();
    const { currentUser } = this.context;

    const hasPaidConfirmed = () =>
      (payment && payment.payment && payment.payment.paid_at) ||
      (homeApplication &&
        homeApplication.payment &&
        homeApplication.payment.paid_at);

    if (!hasPaidConfirmed() || currentUser.isAdmin)
      return (
        <BackButtonContainer addMargin={isForAdvisor} onClick={onPrevStep}>
          <BackButton
            color={isForAdvisor ? color : '#4a4a4a'}
            text={prevStepText}
          />
        </BackButtonContainer>
      );
  };

  renderCancelOption = (
    appWasPayedWithCard: boolean,
    appWasPayedWithPromo: boolean
  ) => {
    const { onCancel, isForAdvisor, color } = this.props;
    if (!appWasPayedWithCard && !appWasPayedWithPromo) {
      return (
        <CancelAppButton
          isForAdvisor={isForAdvisor}
          color={isForAdvisor ? color : '#4a4a4a'}
          onClick={onCancel}
        >
          Cancelar aplicación
        </CancelAppButton>
      );
    }
  };

  renderTitle = () => {
    return <Title>Paga tu investigación</Title>;
  };

  render() {
    const {
      homeAppData,
      redirectPage,
      promoCodePayComplete,
      errorPaymentPromo,
      paymentData,
      showLoadingPromo
    } = this.state;
    const { isForAdvisor, color } = this.props;
    if (redirectPage) {
      return <Redirect to={redirectPage} />;
    }
    let appWasPayedWithCard,
      appWasPayedWithPromo = null;
    if (this.state.paymentData) {
      appWasPayedWithCard =
        this.state.paymentData &&
        !this.state.paymentData.error &&
        this.state.paymentData.payment.paid_at &&
        this.state.paymentData.payment.payment_method === 'card';
      appWasPayedWithPromo =
        this.state.paymentData &&
        !this.state.paymentData.error &&
        ['Promo code', 'postponed screening pay'].includes(
          this.state.paymentData.payment.payment_method
        );
    } else {
      appWasPayedWithCard =
        homeAppData.payment &&
        homeAppData.payment.paid_at &&
        homeAppData.payment.payment_method === 'card';
    }
    return (
      <ProfileContainer>
        <ProfileForm addMargin={isForAdvisor}>
          {this.renderTitle()}
          {this.renderDescription(homeAppData)}
          {this.renderGetBill()}
          {this.errorNotExistLegalEntity()}
          <LinkStyleFacturar
            color={color}
            visible={this.state.require_invoice && !appWasPayedWithCard}
          >
            Datos de facturación
            <IconContent visible={this.state.arrowDownBill}>
              <DownArrowIcon
                color={color}
                onClick={() => {
                  this.toggleBillingData();
                }}
              />
            </IconContent>
            <IconContent visible={this.state.arrowUpBill}>
              <UpArrowIcon onClick={this.toggleBillingData} color={color} />
            </IconContent>
          </LinkStyleFacturar>
          <LineBreak>
            <BillPayment
              visible={
                this.state.billPaymentDataVisible && !appWasPayedWithCard
              }
              allowBilling={false}
              handleClickNotBillAction={this.handleNoBill}
              onBillRequestSuccess={() => {}}
              concept="screening"
              recordId={homeAppData.id}
              updateLegalEntityStatus={this.updateLegalEntityStatus}
              showNotBilling={false}
              operationFrom="homeApplicationPayment"
              isForAdvisor={isForAdvisor}
              color={color}
            />
          </LineBreak>
          {this.renderAlertStubCreated()}
          <div style={{ display: 'inline-block' }}>
            <DiscountPaymentComponent
              visible={!appWasPayedWithCard && !appWasPayedWithPromo}
              homeApp={this.props.homeAppData}
              handlePromoCode={this.handlePromoCode}
              color={color}
            />
          </div>
          {promoCodePayComplete &&
            !appWasPayedWithCard &&
            !appWasPayedWithPromo && (
              <div>
                <ButtonFinish
                  onClick={() => {
                    this.payHomeApplicationCompletePromoCode();
                  }}
                >
                  Aceptar promoción 100%
                </ButtonFinish>
                {showLoadingPromo && (
                  <div style={{ textAlign: 'center', display: 'block' }}>
                    <Spinner color={color} /> Procesando el pago ...
                  </div>
                )}
                {errorPaymentPromo && paymentData && (
                  <strong
                    style={{
                      textAlign: 'center',
                      color: 'red',
                      display: 'block'
                    }}
                  >
                    Error: {paymentData.error}
                  </strong>
                )}
              </div>
            )}
          {this.renderShowPaymentComponent(
            appWasPayedWithCard,
            promoCodePayComplete
          )}
          {this.renderShowTerminarApplication(
            appWasPayedWithCard,
            appWasPayedWithPromo
          )}
        </ProfileForm>
        {this.renderCancelOption(appWasPayedWithCard, appWasPayedWithPromo)}
        {this.renderBackButton()}
      </ProfileContainer>
    );
  }
}
PaymentContentComponent.contextType = HomieContext;
export default PaymentContentComponent;
